module.exports = __webpack_public_path__ + "static/img/loading.e46bd3c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 40